import { render } from "./EditShipping.vue?vue&type=template&id=64ec36c6&scoped=true"
import script from "./EditShipping.vue?vue&type=script&lang=js"
export * from "./EditShipping.vue?vue&type=script&lang=js"

import "./EditShipping.vue?vue&type=style&index=0&id=64ec36c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ec36c6"]])

export default __exports__